import { Box, Container, IconButton, Tooltip, Typography } from "@mui/material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { useOrgTheme } from "../providers/orgThemeProvider";
import { contrastTextFor } from "../theme/buildTheme";

/**
 * Branded header for a public organisation page: the organisation's logo and
 * name on its own colour, with a light/dark toggle.
 */
export default function OrgHeader({ organisation }) {
  const { mode, toggleTheme } = useOrgTheme();

  const brand = organisation?.primary_color || "#000000";
  const onBrand = contrastTextFor(brand);
  const name = organisation?.name || "Rankings";

  return (
    <Box
      component="header"
      sx={{ backgroundColor: brand, color: onBrand, py: { xs: 3, sm: 4 } }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, minWidth: 0 }}>
            {organisation?.logo_url && (
              <Box
                component="img"
                src={organisation.logo_url}
                alt=""
                sx={{
                  height: { xs: 44, sm: 60 },
                  width: "auto",
                  maxWidth: 160,
                  objectFit: "contain",
                  flexShrink: 0,
                }}
              />
            )}

            <Box sx={{ minWidth: 0 }}>
              <Typography
                variant="h1"
                sx={{
                  color: "inherit",
                  fontSize: { xs: "1.35rem", sm: "2rem" },
                  lineHeight: 1.2,
                }}
              >
                {name}
              </Typography>

              {organisation?.hero_title && (
                <Typography
                  variant="h5"
                  sx={{ color: "inherit", opacity: 0.85, mt: 0.5 }}
                >
                  {organisation.hero_title}
                </Typography>
              )}
            </Box>
          </Box>

          <Tooltip title={mode === "light" ? "Dark mode" : "Light mode"}>
            <IconButton
              onClick={toggleTheme}
              sx={{ color: onBrand, flexShrink: 0 }}
              aria-label="Toggle light and dark mode"
            >
              {mode === "light" ? <Brightness4Icon /> : <Brightness7Icon />}
            </IconButton>
          </Tooltip>
        </Box>

        {organisation?.hero_subtitle && (
          <Typography
            variant="body1"
            sx={{ color: "inherit", opacity: 0.85, mt: 2, maxWidth: "60ch" }}
          >
            {organisation.hero_subtitle}
          </Typography>
        )}
      </Container>
    </Box>
  );
}
